"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadImageToS3 = void 0;
var uploadImageToS3_1 = require("./uploadImageToS3");
Object.defineProperty(exports, "uploadImageToS3", { enumerable: true, get: function () { return uploadImageToS3_1.uploadImageToS3; } });
